import styles from './Chips.module.css';

/** Toggle-button group. The count is part of each button's accessible name ("Active last 7 days, 10"). */
const Chips = ({ label, options, value, onChange }) => (
    <div role="group" aria-label={label} className={styles.chips}>
        {options.map(option => {
            const hasCount = option.count !== undefined && option.count !== null;
            return (
                <button
                    key={option.key}
                    type="button"
                    className={styles.chip}
                    aria-pressed={value === option.key}
                    aria-label={hasCount ? `${option.label}, ${option.count}` : undefined}
                    onClick={() => onChange(option.key)}
                >
                    {option.label}
                    {hasCount && <span className={styles.n}>{option.count}</span>}
                </button>
            );
        })}
    </div>
);

export default Chips;
